export const container = {
    display: 'flex',
    alignItems: 'center',
    marginRight: 30,
};
